import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./styles/subscriptionTicker.css";

const TICKER_TEXT =
  "আপনার সাবস্ক্রিপশনের মেয়াদ শেষ হয়ে গেছে। অনুগ্রহ করে দ্রুত পেমেন্ট সম্পন্ন করুন। অন্যথায় সিস্টেমের সেবা বন্ধ হয়ে যাবে।";

const HIDDEN_PATHS = ["/", "/login"];
const REPEAT_COUNT = 6;

function SubscriptionTicker() {
  const { pathname } = useLocation();
  const isLoginPage = HIDDEN_PATHS.includes(pathname);

  useEffect(() => {
    if (isLoginPage) {
      document.body.classList.remove("has-subscription-ticker");
      return;
    }
    document.body.classList.add("has-subscription-ticker");
    return () => document.body.classList.remove("has-subscription-ticker");
  }, [isLoginPage]);

  if (isLoginPage) {
    return null;
  }

  const items = Array.from({ length: REPEAT_COUNT }, (_, i) => (
    <span key={i} aria-hidden={i > 0}>
      {TICKER_TEXT}
    </span>
  ));

  return (
    <div className="subscription-ticker" role="status" aria-live="polite">
      <div className="subscription-ticker__label">সতর্কতা</div>
      <div className="subscription-ticker__track">
        <div className="subscription-ticker__content">
          <div className="subscription-ticker__group">{items}</div>
          <div className="subscription-ticker__group" aria-hidden="true">
            {items}
          </div>
        </div>
      </div>
      <div className="subscription-ticker__status">
        <span className="subscription-ticker__pulse" aria-hidden="true" />
        <span>সাবস্ক্রিপশন এক্সপায়ার্ড</span>
      </div>
    </div>
  );
}

export default SubscriptionTicker;
